/**
 * SSE event block (한 event = `\n\n` 으로 끝나는 한 덩어리) 에서 data 라인들을 합쳐
 * 하나의 문자열로 반환. 표준 SSE 의 multi-line per event 를 올바르게 처리한다.
 *
 * 서버 측에서 `id: <seq>\ndata: <json>\n\n` 형태로 SSE id 필드를 보내기 시작했는데,
 * 기존 클라이언트 파서는 첫 줄이 `data:` 인지만 보고 통째로 skip 했다. 그 회귀를
 * 막기 위해 표준 line-by-line 으로 통일.
 *
 * - `:` 로 시작하는 라인 = comment (heartbeat 용 `: ready` / `: keep-alive`)
 * - 빈 라인 = (이미 분할 단위지만 안전을 위해) 무시
 * - `data:` = body 누적
 * - `id:` / `event:` / `retry:` = 본 fetch 기반 reader 에서는 현재 무시
 *   (EventSource 와 달리 fetch 는 Last-Event-ID 를 자동 보내지 않으며, resumable
 *    stream 구현은 별도 후속 작업)
 *
 * data 라인이 한 줄도 없으면 null 반환.
 */
export function parseSseEventBlock(ev: string): string | null {
  const dataLines: string[] = [];
  for (const raw of ev.split('\n')) {
    const line = raw.replace(/\r$/, '');
    if (line === '' || line.startsWith(':')) continue;
    if (line.startsWith('data:')) {
      // SSE 표준: "data: foo" → "foo" (첫 공백 한 칸 trim)
      dataLines.push(line.slice(5).replace(/^ /, ''));
    }
    // 그 외 (id:, event:, retry:) 는 무시
  }
  if (dataLines.length === 0) return null;
  return dataLines.join('\n');
}
